export enum NameApiProvider {
  WABOXAPP = 'WABOXAPP',
  MESSENGERPEOPLE = 'MESSENGERPEOPLE',
  MESSENGERPEOPLE_DOPPLER = 'MESSENGERPEOPLE_DOPPLER',
  INSTAGRAM = 'INSTAGRAM',
  EMAIL = 'EMAIL',
  WHATSAPP_API_CLOUD = 'WHATSAPP_API_CLOUD',
  WHATSAPP_LITE_API = 'WHATSAPP_LITE_API',
  FACEBOOK = 'FACEBOOK',
  BEPLIC = 'BEPLIC',
}
